import { render, staticRenderFns } from "./CarouselMini.vue?vue&type=template&id=2a6a2949&"
import script from "./CarouselMini.vue?vue&type=script&lang=js&"
export * from "./CarouselMini.vue?vue&type=script&lang=js&"
import style0 from "./CarouselMini.vue?vue&type=style&index=0&id=2a6a2949&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports